import {
  Navigate,
  Route,
  Routes,
  useNavigate,
  useParams,
} from "react-router-dom";

import NotFound from "../NotFound";
// import {FailedPaymentScreen, SuccessPaymentScreen} from "./screens";
//import FindTransactionContainer from "./screens/FindTransactionScreen/Container";
import { SubTabs } from "../../components";
import {
  SUPERAGENT_TABS,
  SUPERAGENT_TABS_FOR_ADMIN,
} from "../../values/subTabs";
import { useEffect, useState, useTransition } from "react";
import { ITopMenuItem } from "../../types/common.interface";
// import "./index.scss";
import Cookies from "js-cookie";
import constants from "../../values/constants";
import utils from "../../utils";
import MunicipalityProvinceContainer from "./Screen/SuperAgent.province/Container";
import MunicipalityCityContainer from "./Screen/SuperAgent.city/Container";
import { useTranslation } from "react-i18next";

const EducationRoute = () => {
  const navigate = useNavigate();

  const param = useParams()["*"];

  const [selectedTab, setSelectedTab] = useState<ITopMenuItem>();

  function onTabClick(tab: any) {
    navigate(tab.pathname);
    setSelectedTab(tab);
  }

  const userType = utils.stringHexConversion.reverse(
    Cookies.get(constants.USER.TYPE)
  );

  const { t } = useTranslation();
  let tabs = userType === "ADMIN" ? SUPERAGENT_TABS_FOR_ADMIN : SUPERAGENT_TABS;
  tabs = tabs.map((item) => ({ ...item, value: t(item.value) }));

  useEffect(() => {
    setSelectedTab(
      tabs.find((item) => item.pathname === param) as ITopMenuItem
    );
  }, [param]);

  return (
    <section id="setting-screen">
      <SubTabs
        tabs={tabs}
        onClick={onTabClick}
        selected={selectedTab as ITopMenuItem}
      />
      <Routes>
        <Route
          path="/"
          element={
            <Navigate
              to={
                userType === "ADMIN" ? "education-province" : "education-city"
              }
            />
          }
        />
        <Route
          path="/education-province"
          element={<MunicipalityProvinceContainer />}
        />
        <Route path="/education-city" element={<MunicipalityCityContainer />} />
        {/* <Route path="/failed-payment-page" element={<FailedPaymentScreen />} />
        <Route path="/payment-page" element={<SuccessPaymentScreen />} /> */}
        <Route path="/*" element={<NotFound />} />
      </Routes>
    </section>
  );
};

export default EducationRoute;
